import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import {
  Box,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import NetworkAPI from 'api/faber/NetworkAPI'
import OrbitSession from 'hooks/useCookies'

function ViewWhitelist() {
  const params = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const faberToken = OrbitSession.get('faberToken')

  const {
    data: networkDetailsData,
    isFetching,
    isError,
    error
  } = useQuery(
    ['getNetworkDetailData', params?.id, params?.version],
    async () =>
      NetworkAPI.getNetworkDetailData(
        params.id as string,
        faberToken,
        params.version
      )
  )

  const responseData = networkDetailsData?.data?.data ?? []
  let headers = []

  if (responseData.length) {
    headers = responseData[0]
  }

  return (
    <Box>
      <Typography variant='h4'>
        [{params?.id ?? ''}] {location.state?.name ?? ''}
      </Typography>
      <Typography variant='body1'>Version: {params?.version ?? ''}</Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mb: '10px'
        }}
      >
        <Button
          onClick={() => {
            navigate(-1)
          }}
          size='small'
        >
          <ArrowBackIcon /> Go Back
        </Button>
      </Box>
      {isError && (
        <Box color='red'>
          {
            // @ts-expect-error response will be there
            error?.response?.data?.message ?? 'Error! Contact Developers'
          }
        </Box>
      )}
      {isFetching ? (
        <CircularProgress />
      ) : !isError ? (
        <TableContainer sx={{ maxHeight: '80vh' }}>
          <Table stickyHeader={true} sx={{ height: '500px' }}>
            <TableHead>
              <TableRow>
                <TableCell>S.No.</TableCell>
                {headers?.map((heading) => (
                  <TableCell key={heading}>{heading}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {responseData
                .slice(1)
                .map((item: Array<string>, index: number) => {
                  return (
                    <TableRow key={item[0][0] + item[0][1]}>
                      <TableCell>{index + 1}</TableCell>
                      {item?.map((cellData: string) => (
                        <TableCell key={cellData}>{cellData}</TableCell>
                      ))}
                    </TableRow>
                  )
                })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : null}
    </Box>
  )
}

export default ViewWhitelist
